module.exports = __webpack_public_path__ + "img/prize-02.ecb792c4.png";